import React,{useEffect, useState} from 'react';
import { useForm } from 'react-hook-form';
import { H6, Image, UL, LI, Btn } from '../../../AbstractElements';

import SvgIcon from '../../Common/Component/SvgIcon';
import { Modal, ModalBody, ModalHeader,ModalFooter,FormGroup, Form, Label } from 'reactstrap';
import RequiredField from '../../../Constant';
import CloseModal from '../../../Constant/CloseModal';
import { UpcomingAppointmentList } from '../../../apiController';

const ScheduleListBox = ({ data, isOpenFun, isOPen, sch }) => {

  const [formdata, setFormdata] = useState({ date: "", time: "", reason: "", service: ""});

  const {
      register,
      handleSubmit,
      formState: { errors },
      reset
    } = useForm();

  const onSubmit = async (data) => {
    console.log(data)
    setFormdata((prev) => ({ ...prev, ...data }));
    // setSteps((prev) => prev + 1);
    // const formattedData = {
    //   role: data.role,
    //   description: data.description,
    //   id: data.id
    // }

    // console.log(formattedData)

//     try {
//       if (rowData) {
//           const response = await UpdatePharmacy(formattedData);
//           if (response.status === true) {
//               toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
//           }
//           navigate(`${process.env.PUBLIC_URL}/pharmacy/:layout>}`)
//       } else {
//           const response = await CreatePharmacy(formattedData);
//           if (response.status === true) {
//               toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
              
//           }
//           navigate(`${process.env.PUBLIC_URL}/pharmacy/:layout>}`)
//       }
//   } catch (error) {
//       toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
//   } UpcomingAppointmentList
    reset()
    
  };
  
  return (
    <>
    {data.length >0  ? 
    <UL attrUL={{ className: 'schedule-list d-flex' }}>
      {data.map((item, i) => (
        <LI key={i} attrLI={{ className: `${item.color} justify-content-between` }}>
          {/* <Image attrImage={{ src: require(`../../../assets/images/dashboard/user/${item.image}`), alt: 'profile' }} /> */}
          <div>
            <H6 className='mb-1'>{item.title}</H6>
            <UL>
              <LI attrLI={{ className: 'f-light' }}>
                <SvgIcon iconId={item.icon} className='fill-icon f-light' />
                <span>{item.date}</span>
              </LI>
              <LI attrLI={{ className: 'f-light' }}>
                <SvgIcon iconId={item.icon2} className='fill-icon f-success' />
                <span> {item.date2}</span>
              </LI>
            </UL>
          </div>
          {/* <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary',  }}>{}</Btn> */}
          {/* <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: ()=>isOpenFun("id") }}>Reschedule</Btn> */}
        </LI>
      ))}
    </UL> : "No Appointments available"}
    <Modal isOpen={isOPen} centered scrollable size='lg'>
    <div className="d-flex justify-content-between text-white bg-dark align-items-center">
    {sch !== ""? <ModalHeader>Inquiry for Resheduling</ModalHeader> : <ModalHeader>Inquiry for Booking</ModalHeader>}  
              <div className='p-3' style={{cursor: "pointer"}} onClick={isOpenFun}> <CloseModal/> </div>
            </div>
 
    
            <ModalBody>
            <Form onSubmit={handleSubmit(onSubmit)} className="form-bookmark needs-validation">
                <FormGroup>
                    <Label>Date <RequiredField/></Label>
                    <input className={`form-control ${errors.role && "is-invalid"}`} id="date" type="date" name="date" defaultValue={formdata.date } {...register("date", { required: true })} />
                    <span className="text-danger">{errors.date && "Date is required"}</span>
                </FormGroup>
                <FormGroup>
                    <Label>Time <RequiredField/></Label>
                    <input className={`form-control ${errors.time && "is-invalid"}`} id="time" type="time" name="time" defaultValue={formdata.time } {...register("time", { required: true })} />
                    <span className="text-danger">{errors.time && "Time is required"}</span>
                </FormGroup>
                <FormGroup>
                    <Label>Reason</Label>
                    <input className={`form-control ${errors.reason && "is-invalid"}`} id="reason" type="text" name="reason" placeholder='e.g. Emergency' defaultValue={formdata.reason } {...register("reason", { required: true })} />
                    <span className="text-danger">{errors.reason && "Reason is required"}</span>
                </FormGroup>
                <FormGroup>
                {sch !== ""? <Label>Booked for <RequiredField/></Label>:<Label>Booking for <RequiredField/></Label>}
                    <select className={`form-control ${errors.categoryw && "is-invalid"}`} id="member" name="member" value={formdata.member} {...register("member", { required: true })} >
                    <option value="">Select Member</option>
                    <option value="myself">My self</option>
                    <option value="person1">Person1</option>
                    <option value="person2">Person2</option>
                    </select>
                </FormGroup>
                <FormGroup>
                    <Label>Dental Clinic</Label>
                    <select className={`form-control ${errors.clinic && "is-invalid"}`} id="clinic" name="clinic" value={formdata.clinic} {...register("clinic", { required: true })} >
                    <option value="">Select Dental Clinic</option>
                    <option value="general">Witte Dental Clinic</option>
                    <option value="dentistry">Dental Clinic</option>
                    </select>
                </FormGroup>
                <FormGroup>
                    <Label>Location</Label>
                    <select className={`form-control ${errors.location && "is-invalid"}`} id="location" name="location" value={formdata.location} {...register("location", { required: true })} >
                    <option value="">Select Location</option>
                    <option value="general">Salem</option>
                    <option value="dentistry">Coimbatore</option>
                    </select>
                </FormGroup>
                <FormGroup>
                    <Label>Category</Label>
                    <select className={`form-control ${errors.category && "is-invalid"}`} id="category" name="category" value={formdata.category} {...register("category", { required: true })} >
                    <option value="">Select Category</option>
                    <option value="general">General Category</option>
                    <option value="dentistry">Dentistry Category</option>
                    </select>
                </FormGroup>
                <FormGroup>
                    <Label>Service</Label>
                    <select className={`form-control ${errors.service && "is-invalid"}`} id="service" name="service" value={formdata.service} {...register("service", { required: true })} >
                    <option value="">Select Category</option>
                    <option value="generalservice">General service</option>
                    <option value="dentistryservice">Dentistry service</option>
                    </select>
                </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
              <Btn attrBtn={{ color: 'secondary', onClick: isOpenFun }}>{"Close"}</Btn>
              <Btn attrBtn={{ color: 'primary', type: 'submit' }}>{"Book"}</Btn>
          </ModalFooter>

    </Modal>
    </>
  );
};

export default ScheduleListBox;
